import React from "react";
import { Control } from "react-hook-form";

import { ValidationError } from "@/lib/hook/useValidation";

import ControlledInputWithRaisingLabel from "@/components/FormElements/ControlledInputWithRaisingLabel";

import {
  ConfigParamValueWithModifiers,
  ImmigramFormElementConfigBase,
  ImmigramFormElementOnChange,
  ImmigramFormElementType,
  useModifiedConfigParamValue,
} from "./common";

export interface ImmigramFormElementConfigDate
  extends ImmigramFormElementConfigBase {
  type: ImmigramFormElementType.Date;
  name: string;
  title: ConfigParamValueWithModifiers;
}

interface ImmigramFormDateProps {
  elementConfig: ImmigramFormElementConfigDate;
  control: Control;
  onChange: ImmigramFormElementOnChange;
  disabled: boolean;
  validationErrors?: ValidationError | null;
}

function ImmigramFormDate({
  elementConfig,
  control,
  onChange,
  disabled,
  validationErrors,
}: ImmigramFormDateProps) {
  const title = useModifiedConfigParamValue(elementConfig.title);

  return (
    <ControlledInputWithRaisingLabel
      control={control}
      type="date"
      label={title}
      fieldName={elementConfig.name}
      onChange={onChange}
      disabled={disabled}
      error={validationErrors?.message}
    />
  );
}

export { ImmigramFormDate };
